import React from 'react'
import share from '../../../assets/images/icons/share.svg'
import { useShare } from './hooks/useShare'
import {
  CargoItemInterface,
  SlotItemInterface,
  TransportItemInterface,
} from '../../types/interfaces'
import { ExecutorInterface } from '../../types/interfaces'
import { Modal } from '../modal/Modal'
import ShareModalContent from './components/shareModalContent/ShareModalContent'
import { IconButton } from '../iconButton/IconButton'

type Props = {
  order?: SlotItemInterface | CargoItemInterface | TransportItemInterface
  executor?: ExecutorInterface
}

const Share = ({ order, executor }: Props) => {
  const { modalActive, setModalActive, generateLinkAndText, chatShareAction } = useShare(
    order,
    executor,
  )

  return (
    <div>
      <IconButton
        small
        display
        icon={share}
        alt="Поделиться"
        onClick={() => {
          setModalActive(true)
        }}
      />

      <Modal modalActive={modalActive} setModalActive={setModalActive}>
        <ShareModalContent
          text={generateLinkAndText().text}
          url={generateLinkAndText().url}
          setModalActive={setModalActive}
          chatShareAction={chatShareAction}
        />
      </Modal>
    </div>
  )
}

export default Share
